export default __webpack_public_path__ + "static/media/x-Bitcoinbg.21dc4e22.png";